export function findAttrInNodeTree(node, getAttr) {
  const attribute = getAttr(node);
  if (!attribute && node.parentElement) {
    return findAttrInNodeTree(node.parentElement, getAttr);
  }
  return attribute;
}